import { useEffect, useRef } from 'react';

export const SkipToken = Symbol();

export function useCertainCleanup<A>(
  cleanupFn: (arg: A) => unknown,
  getArgs: () => A | typeof SkipToken,
  deps: unknown[] = [],
) {
  const cleanupRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    clearTimeout(cleanupRef.current);
    cleanupRef.current = undefined;

    return () => {
      const arg = getArgs();

      if (arg !== SkipToken) {
        cleanupRef.current = setTimeout(() => cleanupFn(arg));
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
